import {
    SolveCornerPlacementModelMode,
    type SolveCornerPlacementModel
} from 'api/models';
import { EMPTY_GUID } from 'shared/constants';

import type { PlacementState } from 'app/modules/wallforming/components/state-management/placement/types';

export interface BuildSolveCornerPlacementRequestOptions {
    state: PlacementState;
    sessionId: string;
    systemId: string;
    poiIndex: number;
    mode?: SolveCornerPlacementModelMode;
    selectedCornerArticleGuid?: string | null;
}

export function buildSolveCornerPlacementRequest(
    options: BuildSolveCornerPlacementRequestOptions
): SolveCornerPlacementModel {
    const { state, sessionId, systemId, poiIndex } = options;
    const cornerSettings = state.automatedPlacementSettingsByType.Corners;

    const poiId = state.pois[poiIndex]?.poi.poiGuid ?? EMPTY_GUID;

    return {
        sessionId,
        poiId,
        systemId,
        existingPlacements: [],
        mode: options.mode ?? SolveCornerPlacementModelMode.Automatic,
        selectedCornerArticleGuid: options.selectedCornerArticleGuid,
        solverCostWeights: cornerSettings.solverCostWeights
    };
}
